import React from "react";
import { twMerge } from "tailwind-merge";
import type { ICallState } from "../../store/@types/chat";

type ICallStatusPanel = {
  callState: Exclude<ICallState, "idle">;
};

const COPY: Record<ICallStatusPanel["callState"], { title: string }> = {
  connecting: { title: "Connecting your live call..." },
  listening: { title: "I'm listening — take your time" },
  thinking: { title: "One moment…" },
  speaking: { title: "Speaking — talk over me or press Space" },
};
const CallStatusPanel: React.FC<ICallStatusPanel> = ({ callState }) => {
  const { title } = COPY[callState];

  return (
    <div className="flex flex-1 flex-col items-center justify-center px-6 py-10 text-center sm:py-14">
      <div className="relative flex h-24 w-24 items-center justify-center">
        <span
          className={twMerge(
            "absolute inline-flex h-full w-full rounded-full bg-emerald-300 opacity-60",
            callState === "listening" && "animate-ping",
          )}
        />
        <span className="relative h-16 w-16 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600" />
      </div>

      <p className="mt-6 text-lg font-semibold text-slate-900">{title}</p>
      <p className="mx-auto mt-2 max-w-xs text-sm text-slate-500">
        Speak naturally — finish long sentences at your pace. Tap interrupt (or
        press Space) while I&apos;m talking.
      </p>
    </div>
  );
};

export default CallStatusPanel;
